module.exports = __webpack_public_path__ + "static/media/voucherTutorial.df34f571.mp4";